// ---- FORMAT OF THE FILTERS OBJECT ---
// {
//   statuses: ["IN_PROGRESS"],
//   productFamilies: ["615dd4d554bcf50019d109ae"],
//   folders: ["69c6a5881d6a707c80e7c3b8", "69c6a5901d6a707c80e7c3bc"],
//   updatedAt: {
//     $gte: "2026-04-20T00:00:00.000Z",
//     $lte: "2026-04-24T00:00:00.000Z",
//   },
//   result: {
//     $gte: 0,
//     $lte: 20,
//   },
// };

export const convertCalculsFilters = (filtersObj) => {
  let filters = "";

  // --- Statuses ---
  if (filtersObj?.statuses && filtersObj.statuses.length > 0) {
    filters += filtersObj.statuses
      .map((status) => `&status[]=${encodeURIComponent(status)}`)
      .join("&");
  }
  // --- Product Families ---
  if (filtersObj?.productFamilies && filtersObj.productFamilies.length > 0) {
    filters += filtersObj.productFamilies
      .map((family) => `&productFamily.id[]=${encodeURIComponent(family.id)}`)
      .join("&");
  }
  // --- Folders ---
  if (filtersObj?.folders && filtersObj.folders.length > 0) {
    filters += filtersObj.folders
      .map((folder) => `&folders[$in][]=${encodeURIComponent(folder.id)}`)
      .join("&");
  }
  // --- Updated At ---
  if (
    filtersObj?.updatedAt &&
    (filtersObj.updatedAt.$gte || filtersObj.updatedAt.$gte === 0) &&
    (filtersObj.updatedAt.$lte || filtersObj.updatedAt.$lte === 0)
  ) {
    filters += `&updatedAt[$gte]=${encodeURIComponent(new Date(filtersObj.updatedAt.$gte).toISOString())}&updatedAt[$lte]=${encodeURIComponent(new Date(filtersObj.updatedAt.$lte).toISOString())}`;
  }
  // --- Result ---
  if (
    filtersObj?.result &&
    (filtersObj.result.$gte || filtersObj.result.$gte === 0) &&
    (filtersObj.result.$lte || filtersObj.result.$lte === 0)
  ) {
    filters += `&metrics.referenceValue[$gte]=${encodeURIComponent(filtersObj.result.$gte)}&metrics.referenceValue[$lte]=${encodeURIComponent(filtersObj.result.$lte)}`;
  }
  return filters;
};
